import { gql } from '@apollo/client'
import { Banner, InformationIcon } from '@farol-ds/react'
import { formatToRelativeDate } from '@jusbrasil-web/shared-relative-date'

import { NewsDisclaimer_DocumentFragment } from './__generated__/news-disclaimer.graphql'

export type NewsDisclaimer = {
  document: NewsDisclaimer_DocumentFragment
}

export function NewsDisclaimer({ document }: NewsDisclaimer) {
  const { isAIGenerated } = document
  const publishedDate = Number(document.publishedDate)

  const getTimeDifferenceInDays = () => {
    const MS_PER_DAY = 86400000
    const now = Date.now()
    return Math.round((now - publishedDate) / MS_PER_DAY)
  }
  const publishedOver30DaysAgo = publishedDate > 0 && getTimeDifferenceInDays() >= 30
  const relativeDate = formatToRelativeDate(new Date(publishedDate), new Date())

  if (!publishedOver30DaysAgo && !isAIGenerated) {
    return null
  }

  return (
    <Banner type="info">
      <Banner.Content>
        <Banner.Title>
          <Banner.Icon>
            <InformationIcon />
          </Banner.Icon>
          {isAIGenerated && <>Este conteúdo foi criado com auxílio de Inteligência Artificial. </>}
          {publishedOver30DaysAgo && (
            <>Publicado {relativeDate} por uma fonte possivelmente não jornalística.</>
          )}
        </Banner.Title>
      </Banner.Content>
    </Banner>
  )
}

NewsDisclaimer.fragments = {
  document: gql`
    fragment NewsDisclaimer_document on Document {
      isAIGenerated
      publishedDate
    }
  `,
}
